// client/src/coms/presence/durations.js
// The free duration used by timed statuses (Appear offline, Idle / AFK, Do Not Disturb): any whole number of
// minutes, hours, days or weeks, or "until I turn it off". The server checks the same rules (utils/presenceStore.js).
export const UNITS = [
  { value: 'minutes', label: 'Minutes', ms: 60000 },
  { value: 'hours', label: 'Hours', ms: 3600000 },
  { value: 'days', label: 'Days', ms: 86400000 },
  { value: 'weeks', label: 'Weeks', ms: 604800000 },
];
const MAX_MS = 520 * 604800000;

export const DEFAULT_DURATION = { amount: '1', unit: 'hours', forever: false };

export function durationError(d) {
  if (!d || d.forever) return '';
  const raw = String(d.amount == null ? '' : d.amount).trim();
  if (!/^\d+$/.test(raw) || Number(raw) < 1) return 'Enter a whole number of 1 or more.';
  const unit = UNITS.find((u) => u.value === d.unit);
  if (!unit) return 'Choose minutes, hours, days or weeks.';
  if (Number(raw) * unit.ms > MAX_MS) return 'That is longer than ten years; choose “Until I turn it off” instead.';
  return '';
}

// For PUT /api/presence/status: null = until turned off.
export function toApiDuration(d) {
  if (!d || d.forever) return null;
  return { value: Number(String(d.amount).trim()), unit: d.unit };
}

function plural(n, word) {
  return `${n} ${word}${n === 1 ? '' : 's'}`;
}

// "1 hour 20 minutes", "3 days 4 hours", "less than a minute".
export function formatRemaining(ms) {
  const m = Math.round(Math.max(0, ms) / 60000);
  if (m < 1) return 'less than a minute';
  const weeks = Math.floor(m / 10080);
  const days = Math.floor((m % 10080) / 1440);
  const hours = Math.floor((m % 1440) / 60);
  const mins = m % 60;
  if (weeks) return [plural(weeks, 'week'), days ? plural(days, 'day') : ''].filter(Boolean).join(' ');
  if (days) return [plural(days, 'day'), hours ? plural(hours, 'hour') : ''].filter(Boolean).join(' ');
  if (hours) return [plural(hours, 'hour'), mins ? plural(mins, 'minute') : ''].filter(Boolean).join(' ');
  return plural(mins, 'minute');
}

export function formatEnds(untilMs) {
  try {
    return new Date(untilMs).toLocaleString(undefined, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch {
    return new Date(untilMs).toString();
  }
}
